import styled, { css } from 'styled-components';

export const LinkContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: ${theme.typography.actions14Sb.fontSize};
    font-weight: ${theme.typography.actions14Sb.fontWeight};
    line-height: ${theme.typography.actions14Sb.lineHeight};
    letter-spacing: ${theme.typography.actions14Sb.letterSpacing};
    color: #214e64; /* tokens-allow: pending design decision */
    background-color: transparent;
    text-decoration: none;
  `,
);
